import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./TaxExemptionForm";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {cancelSetTaxExemption} from "../../actions/AccountApiActions";
import {fromJS, Map} from "immutable";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

function validateForm(values, props) {
  let errors = Map();
  return errors.toJS();
}

class SetTaxExemptionFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    let updatedValues = {
      accountId: this.props.accountId,
      description: values.get("description")
    }

    return this.props.markAccountAsTaxExempt(updatedValues)
      .then((response) => {
        if (response.data.markAccountAsTaxExempt.errors.length <= 0) {
          this.props.cancelSetTaxExemption();
        } else {
          let errors = createValidationErrors(response.data.markAccountAsTaxExempt.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleRemove() {
    return this.props.removeAccountTaxExemption(this.props.accountId)
      .then((response) => {
        if (response.data.removeAccountTaxExemption.errors.length <= 0) {
          this.props.cancelSetTaxExemption();
        } else {
          let errors = createValidationErrors(response.data.removeAccountTaxExemption.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });       
  }

  handleCancel() {
    this.props.cancelSetTaxExemption();
  }

  render() {
    let {data} = this.props;
    if (data.loading) return <Loading />
    if (data.error) return <GraphQLErrors error={data.error} />
    let account = fromJS(data.billingAccount)
    let initialValues = {
      description: account.get("taxExemptionDescription")
    }
    return (
      <Form
        initialValues={initialValues}
        errors={this.state.errors}
        validate={validateForm}
        showRemove={account.get("taxExempt") === true}
        onSubmit={this.handleSubmit.bind(this)}
        onRemove={this.handleRemove.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }
}


const GET_BILLING_INFO = gql`
  query billingAccount($accountId: ID!) {
    billingAccount(accountId: $accountId) {
      shopId
      taxId
      validTaxId
      taxExempt
      taxExemptionDescription
    }
  }
`;

const ASSIGN_TAX_EXEMPTION = gql`
  mutation markAccountAsTaxExempt($data: BillingTaxInput!) {
    markAccountAsTaxExempt(input: $data) {
      errors { key message }
    }
  }
`;

const REMOVE_TAX_EXEMPTION = gql`
  mutation removeAccountTaxExemption($accountId: String!) {
    removeAccountTaxExemption(accountId: $accountId) {
      errors { key message }
    }
  }
`;


const withQueries = compose(
  graphql(GET_BILLING_INFO, {
    options: (props) => ({
      fetchPolicy: "network-only"
    })
  }),
  graphql(ASSIGN_TAX_EXEMPTION, {
    props: ({ mutate }) => ({
      markAccountAsTaxExempt: (data) => mutate({
        variables: { data: data }
      })
    })
  }),
  graphql(REMOVE_TAX_EXEMPTION, {
    props: ({ mutate }) => ({
      removeAccountTaxExemption: (accountId) => mutate({
        variables: { accountId: accountId }
      })
    })
  }),
);


export default connect(null, {cancelSetTaxExemption})(withQueries(SetTaxExemptionFormContainer));

